export const EmailSubjectPrefix = {
    Forward: 'FW: ',
    Reply: 'RE: ',
};
